import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/billing/estimate';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* process(action) {
  try {
    const response = yield call(
      axios.post,
      `${config.API_URL}/billing/estimate`,
      action.payload,
      { headers: getLocalUser() },
    );
    // Unwrap Flask responseJSON envelope ({data: {...}}).
    yield put(fetchSuccess(response.data?.data ?? response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
